// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MoneybotChatOpenEvent
 */
export var MoneybotChatOpen = function (_a) {
    var clientChatId = _a.clientChatId, gooseSessionId = _a.gooseSessionId, surface = _a.surface, nuxId = _a.nuxId;
    return ({
        name: "Moneybot Chat Open",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Chat",
            client_chat_id: clientChatId !== undefined && clientChatId !== null ? clientChatId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            surface: surface !== undefined && surface !== null ? surface.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotChatStartEvent
 */
export var MoneybotChatStart = function (_a) {
    var clientChatId = _a.clientChatId, gooseSessionId = _a.gooseSessionId, campaignToken = _a.campaignToken, suggestionId = _a.suggestionId, clientSuggestionId = _a.clientSuggestionId;
    return ({
        name: "Moneybot Chat Start",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Chat",
            client_chat_id: clientChatId !== undefined && clientChatId !== null ? clientChatId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            suggestion_id: suggestionId !== undefined && suggestionId !== null ? suggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_suggestion_id: clientSuggestionId !== undefined && clientSuggestionId !== null ? clientSuggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotChatCloseEvent
 */
export var MoneybotChatClose = function (_a) {
    var clientChatId = _a.clientChatId, gooseSessionId = _a.gooseSessionId;
    return ({
        name: "Moneybot Chat Close",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Chat",
            client_chat_id: clientChatId !== undefined && clientChatId !== null ? clientChatId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotChatViewHistoryEvent
 */
export var MoneybotChatViewHistory = function (_a) {
    var clientChatId = _a.clientChatId;
    return ({
        name: "Moneybot Chat ViewHistory",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Chat",
            client_chat_id: clientChatId !== undefined && clientChatId !== null ? clientChatId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotEntrypointTapEvent
 */
export var MoneybotEntrypointTap = function () { return ({
    name: "Moneybot Entrypoint Tap",
    parameters: {
        cdf_entity: "Moneybot",
        cdf_action: "Entrypoint",
    }
}); };
/**
 * @see MoneybotQuickActionTapEvent
 */
export var MoneybotQuickActionTap = function (_a) {
    var gooseSessionId = _a.gooseSessionId, gooseMessageId = _a.gooseMessageId, action = _a.action;
    return ({
        name: "Moneybot QuickAction Tap",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "QuickAction",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_message_id: gooseMessageId !== undefined && gooseMessageId !== null ? gooseMessageId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotMessageSendEvent
 */
export var MoneybotMessageSend = function (_a) {
    var inputType = _a.inputType, gooseSessionId = _a.gooseSessionId, messageId = _a.messageId, messageIndex = _a.messageIndex, creationTime = _a.creationTime;
    return ({
        name: "Moneybot Message Send",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Message",
            input_type: inputType !== undefined && inputType !== null ? inputType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_id: messageId !== undefined && messageId !== null ? messageId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_index: messageIndex !== undefined && messageIndex !== null ? messageIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            creation_time: creationTime !== undefined && creationTime !== null ? creationTime.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotTurnGenerateEvent
 */
export var MoneybotTurnGenerate = function (_a) {
    var agentService = _a.agentService, toolPlanPresent = _a.toolPlanPresent, toolPlanNames = _a.toolPlanNames, guardrailFlags = _a.guardrailFlags, guardrailAction = _a.guardrailAction, sessionTokensUsed = _a.sessionTokensUsed, gooseSessionId = _a.gooseSessionId, gooseTurnId = _a.gooseTurnId, messageId = _a.messageId, messageIndex = _a.messageIndex, inputTokensUsed = _a.inputTokensUsed, outputTokensUsed = _a.outputTokensUsed, creationTime = _a.creationTime, cacheCreationInputTokens = _a.cacheCreationInputTokens, cacheReadInputTokens = _a.cacheReadInputTokens, durationSeconds = _a.durationSeconds, outputType = _a.outputType;
    return ({
        name: "Moneybot Turn Generate",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Turn",
            agent_service: agentService !== undefined && agentService !== null ? agentService.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            tool_plan_present: toolPlanPresent !== undefined && toolPlanPresent !== null ? toolPlanPresent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            tool_plan_names: toolPlanNames !== undefined && toolPlanNames !== null ? toolPlanNames.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            guardrail_flags: guardrailFlags !== undefined && guardrailFlags !== null ? guardrailFlags.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            guardrail_action: guardrailAction !== undefined && guardrailAction !== null ? guardrailAction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_tokens_used: sessionTokensUsed !== undefined && sessionTokensUsed !== null ? sessionTokensUsed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_turn_id: gooseTurnId !== undefined && gooseTurnId !== null ? gooseTurnId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_id: messageId !== undefined && messageId !== null ? messageId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_index: messageIndex !== undefined && messageIndex !== null ? messageIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            input_tokens_used: inputTokensUsed !== undefined && inputTokensUsed !== null ? inputTokensUsed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            output_tokens_used: outputTokensUsed !== undefined && outputTokensUsed !== null ? outputTokensUsed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            creation_time: creationTime !== undefined && creationTime !== null ? creationTime.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cache_creation_input_tokens: cacheCreationInputTokens !== undefined && cacheCreationInputTokens !== null ? cacheCreationInputTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cache_read_input_tokens: cacheReadInputTokens !== undefined && cacheReadInputTokens !== null ? cacheReadInputTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_seconds: durationSeconds !== undefined && durationSeconds !== null ? durationSeconds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            output_type: outputType !== undefined && outputType !== null ? outputType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotTurnErrorEvent
 */
export var MoneybotTurnError = function (_a) {
    var gooseSessionId = _a.gooseSessionId, gooseTurnId = _a.gooseTurnId, errorMessage = _a.errorMessage;
    return ({
        name: "Moneybot Turn Error",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Turn",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_turn_id: gooseTurnId !== undefined && gooseTurnId !== null ? gooseTurnId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotToolResponseEvent
 */
export var MoneybotToolResponse = function (_a) {
    var toolName = _a.toolName, success = _a.success, gooseSessionId = _a.gooseSessionId, gooseTurnId = _a.gooseTurnId, messageId = _a.messageId, errorMessage = _a.errorMessage;
    return ({
        name: "Moneybot Tool Response",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Tool",
            tool_name: toolName !== undefined && toolName !== null ? toolName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            success: success !== undefined && success !== null ? success.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_turn_id: gooseTurnId !== undefined && gooseTurnId !== null ? gooseTurnId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_id: messageId !== undefined && messageId !== null ? messageId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotActionCardShowEvent
 */
export var MoneybotActionCardShow = function (_a) {
    var gooseSessionId = _a.gooseSessionId, routeId = _a.routeId, flowType = _a.flowType, plannedRoute = _a.plannedRoute, gooseTurnId = _a.gooseTurnId;
    return ({
        name: "Moneybot ActionCard Show",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "ActionCard",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_id: routeId !== undefined && routeId !== null ? routeId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_type: flowType !== undefined && flowType !== null ? flowType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            planned_route: plannedRoute !== undefined && plannedRoute !== null ? plannedRoute.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goose_turn_id: gooseTurnId !== undefined && gooseTurnId !== null ? gooseTurnId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotActionCardTapEvent
 */
export var MoneybotActionCardTap = function (_a) {
    var gooseSessionId = _a.gooseSessionId, routeId = _a.routeId;
    return ({
        name: "Moneybot ActionCard Tap",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "ActionCard",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_id: routeId !== undefined && routeId !== null ? routeId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotActionCardResultEvent
 */
export var MoneybotActionCardResult = function (_a) {
    var gooseSessionId = _a.gooseSessionId, routeId = _a.routeId, result = _a.result, errorCode = _a.errorCode;
    return ({
        name: "Moneybot ActionCard Result",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "ActionCard",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_id: routeId !== undefined && routeId !== null ? routeId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingViewEvent
 */
export var MoneybotOnboardingView = function (_a) {
    var nuxId = _a.nuxId;
    return ({
        name: "Moneybot Onboarding View",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingTapEvent
 */
export var MoneybotOnboardingTap = function (_a) {
    var nuxId = _a.nuxId;
    return ({
        name: "Moneybot Onboarding Tap",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingStartPlaybackEvent
 */
export var MoneybotOnboardingStartPlayback = function (_a) {
    var nuxId = _a.nuxId;
    return ({
        name: "Moneybot Onboarding StartPlayback",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingEndPlaybackEvent
 */
export var MoneybotOnboardingEndPlayback = function (_a) {
    var nuxId = _a.nuxId;
    return ({
        name: "Moneybot Onboarding EndPlayback",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingErrorPlaybackEvent
 */
export var MoneybotOnboardingErrorPlayback = function (_a) {
    var nuxId = _a.nuxId, errorCode = _a.errorCode;
    return ({
        name: "Moneybot Onboarding ErrorPlayback",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingErrorDisclosuresEvent
 */
export var MoneybotOnboardingErrorDisclosures = function (_a) {
    var nuxId = _a.nuxId;
    return ({
        name: "Moneybot Onboarding ErrorDisclosures",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotOnboardingErrorOptInEvent
 */
export var MoneybotOnboardingErrorOptIn = function (_a) {
    var nuxId = _a.nuxId, errorCode = _a.errorCode;
    return ({
        name: "Moneybot Onboarding ErrorOptIn",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Onboarding",
            nux_id: nuxId !== undefined && nuxId !== null ? nuxId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotSuggestionsViewEvent
 */
export var MoneybotSuggestionsView = function (_a) {
    var suggestionId = _a.suggestionId, campaignCategory = _a.campaignCategory, clientSuggestionId = _a.clientSuggestionId;
    return ({
        name: "Moneybot Suggestions View",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Suggestions",
            suggestion_id: suggestionId !== undefined && suggestionId !== null ? suggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_category: campaignCategory !== undefined && campaignCategory !== null ? campaignCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_suggestion_id: clientSuggestionId !== undefined && clientSuggestionId !== null ? clientSuggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotSuggestionsTapEvent
 */
export var MoneybotSuggestionsTap = function (_a) {
    var suggestionId = _a.suggestionId, campaignCategory = _a.campaignCategory, clientSuggestionId = _a.clientSuggestionId;
    return ({
        name: "Moneybot Suggestions Tap",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Suggestions",
            suggestion_id: suggestionId !== undefined && suggestionId !== null ? suggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_category: campaignCategory !== undefined && campaignCategory !== null ? campaignCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_suggestion_id: clientSuggestionId !== undefined && clientSuggestionId !== null ? clientSuggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotSuggestionsCloseEvent
 */
export var MoneybotSuggestionsClose = function (_a) {
    var suggestionId = _a.suggestionId, campaignCategory = _a.campaignCategory;
    return ({
        name: "Moneybot Suggestions Close",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Suggestions",
            suggestion_id: suggestionId !== undefined && suggestionId !== null ? suggestionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_category: campaignCategory !== undefined && campaignCategory !== null ? campaignCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MoneybotErrorChatErrorEvent
 */
export var MoneybotErrorChatError = function (_a) {
    var gooseSessionId = _a.gooseSessionId, clientChatId = _a.clientChatId, errorName = _a.errorName, endpoint = _a.endpoint;
    return ({
        name: "Moneybot Error ChatError",
        parameters: {
            cdf_entity: "Moneybot",
            cdf_action: "Error",
            goose_session_id: gooseSessionId !== undefined && gooseSessionId !== null ? gooseSessionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_chat_id: clientChatId !== undefined && clientChatId !== null ? clientChatId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_name: errorName !== undefined && errorName !== null ? errorName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            endpoint: endpoint !== undefined && endpoint !== null ? endpoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
